import EditableBlockValue from './EditableBlockValue';

export default EditableBlockValue;
